import { Box, Divider, FormControl, Grid, InputLabel, SelectChangeEvent, Theme, Typography } from '@mui/material';
import React, { Dispatch, SetStateAction, useEffect, useState } from 'react';
import { FamilyListObj, GetFamilyListResponseBody, uboTypes } from '../../redux-store/types/api-types';
import { formatShortDate } from '../../utils/date';
import { KeyValue } from '../ApplicationDetails/personalDetails';
import { Gridstyles, Item, ItemDetails } from '../ApplicationDetails';
import { SubHeading } from '../investors/components';
import { currencyConversion, getUniqueIdentityText, isModuleAllowed } from '../../utils/utilityFunctions';
import { investorTypeMasters, USER_ROLES } from '../../utils/constant';
import { useDispatch, useSelector } from 'react-redux';
import { RootStateType } from '../../redux-store/reducers';
import { getFamilyList } from '../../redux-store/actions/onBoarding';
import { showError } from '../../redux-store/actions/auth';
import { BootstrapSelect } from '../../lib/formik/SelectField';
import { renderFilteredOptions, SearchFieldWrapper } from '../../lib/formik/searchSelectField';
import { getUboTypes } from '../../redux-store/actions/application';

export default function ContributorDetails({
  application,
  selectedFamilyId = { key: "", value: "" },
  setSelectedFamilyId = () => { return; }
}: {
  application: any;
  selectedFamilyId?: { key: string, value: string };
  setSelectedFamilyId?: Dispatch<SetStateAction<{ key: string, value: string }>>;
}): JSX.Element {
  const {
    applicants = [],
    familyName = "",
    familyId = "",
    ubo_declaration_type = '',
    ubo_declaration_value = '',
  } = application

  const dispatch = useDispatch();

  const [familyListData, setFamilyListData] = useState<
    Array<{
      key: string;
      value: string;
    }>
  >([])
  const [query, setQuery] = useState<string>('');
  const [uboTypesMdms, setUboTypesMdms] = useState<uboTypes>();

  const { locale } = useSelector((store: RootStateType) => store.currencyInfo);
  const { company = "WMS" } = useSelector((state: RootStateType) => state.navbarInfo)
  const { role = '' } = useSelector((store: RootStateType) => store.auth);

  const fetchFamilyListData = async () => {
    try {
      const response = await (dispatch(getFamilyList()) as unknown as Promise<GetFamilyListResponseBody>)

      if (!response?.isSuccess) {
        dispatch(showError(response?.message ?? ""))
        return
      }

      if (response?.isSuccess) {
        const modifiedFamilyListData = (response?.familyList ?? []).map((obj: FamilyListObj) => ({
          key: obj?.familyName ?? "",
          value: obj?.familyId ?? ""
        }))

        setFamilyListData(modifiedFamilyListData)
        return
      }
    } catch (error) {
      console.log("Error: ", error)
    }
  }

  useEffect(() => {
    if (
      isModuleAllowed({ value: (role ?? ""), compareArr: [USER_ROLES.AMCAPPROVER] }) &&
      !familyId
    ) {
      fetchFamilyListData()
    }
  }, [])

  useEffect(() => {
    (async function () {
      try {
        const response = (await dispatch(getUboTypes())) as unknown as uboTypes;
        setUboTypesMdms(response);
      } catch (e) {
        console.error((e as Error).message);
      }
    })();
  }, [])

  const getUboDeclarationType = (uboTypesMdmsData: uboTypes, type: string) => {
    return uboTypesMdmsData.uboType
      .map((t) => { if (t.key === type) return t.displayText; })
      .filter((ele) => ele)
      .toString();
  };

  const getUboDeclarationValue = (uboTypesMdmsData: uboTypes, type: string, value: string) => {
    const declarationValue = uboTypesMdmsData.uboType
      .map((t) => {
        if (t.key === type && t.displayOthers) {
          return t.values
            .map((val) => { if (val.key === value) return val.label; })
            .filter((ele) => ele)
            .toString();
        }
      })
      .filter((ele) => ele)
      .toString();
    return declarationValue ? declarationValue : value;
  };

  return (
    <>
      <Box
        sx={(theme: Theme) => ({
          bgcolor: 'white',
          boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.1)',
          borderRadius: '10px',
          border: `1px solid ${theme.palette.grey[100]}`,
          padding: '25px',
        })}
        mt={5}
      >
        <Box>
          <Grid container >
            <Grid item xs={12}>
              <Typography sx={(theme: Theme) => ({ fontSize: 18, fontWeight: 700, color: theme.palette.primary[900], mb: '9px' })}>
                Contributor Details
              </Typography>
            </Grid>
            {applicants.map((applicant: any) => {
              return (
                <React.Fragment key={applicant.id}>
                  <Grid
                    item
                    container
                    // pb={5}
                    rowSpacing={3}
                    columnSpacing={5.5}
                    direction="row"
                  // justifyContent="space-between"
                  // alignItems="flex-start"
                  >
                    <KeyValue title={'Name Of Entity'} description={applicant.name} />
                    <KeyValue
                      title={'Date of Registration/Incorporation'}
                      description={formatShortDate(applicant.dateOfBirth)}
                      sx={{ overflowWrap: 'anywhere' }}
                    />
                    <KeyValue
                      title={'Place of Registration/Incorporation'}
                      description={applicant.cityOfIncorporation}
                      sx={{ overflowWrap: 'anywhere' }}
                    />
                    <KeyValue
                      title={'Country of Registration/Incorporation'}
                      description={applicant?.countryOfIncorporation ?? "-"}
                      sx={{ overflowWrap: 'anywhere' }}
                    />
                    <KeyValue
                      title={'CKYC No./CKYC Acknowledge No./KIN No'}
                      description={applicant.ckycNo}
                    />
                    {applicant.investorType && (
                      <KeyValue
                        title={'Investor Type'}
                        description={investorTypeMasters[applicant.investorType]}
                      />
                    )}
                    <KeyValue title={`${getUniqueIdentityText(company)?.pan}`} description={applicant.panNo} />
                    <KeyValue
                      title={'KRA mobile'}
                      description={applicant?.kraMobileNumber ?? "-"}
                    />
                    <KeyValue
                      title={'KRA Email'}
                      description={applicant?.kraEmailId ?? "-"}
                    />
                    <KeyValue
                      title="Mobile Number"
                      description={
                        applicant?.countryCode
                          ? applicant?.countryCode + '-' + (applicant?.mobile ?? "-")
                          : applicant?.mobile ?? "-"
                      }
                    />
                    <KeyValue
                      title="Email ID"
                      description={applicant?.email ?? "-"}
                    />
                    <KeyValue
                      title={'CIN'}
                      description={applicant?.cin ?? "-"}
                    />
                    <KeyValue
                      title={'TIN/GST'}
                      description={applicant?.gstRegNo ?? "-"}
                    />
                  </Grid>
                  <SubHeading
                    sx={{
                      color: 'common.black',
                      letterSpacing: 0.5 + 'px',
                      padding: { xs: '10px 10px', sm: '10px 30px' },
                    }}>
                    {'Other Details'}
                  </SubHeading>
                  <Grid
                    item
                    container
                    // pb={5}
                    rowSpacing={3}
                    columnSpacing={5.5}
                    direction="row"
                  // justifyContent="space-between"
                  // alignItems="flex-start"
                  >
                    <KeyValue
                      title={'Gross Annual Income'}
                      description={applicant.grossAnnualIncome}
                    />
                    <KeyValue
                      title={'Net Worth'}
                      description={applicant.netWorth}
                      amount={currencyConversion(locale, applicant.netWorth)}
                    />
                    <KeyValue
                      title={'PEP Status'}
                      description={applicant.politicallyExposedPersonStatus}
                    />
                    <KeyValue
                      title={'Networth as on date'}
                      description={applicant?.netWorthDate ? formatShortDate(applicant.netWorthDate) : "-"}
                    />
                  </Grid>
                </React.Fragment>
              );
            })}
            <Grid item xs={12} my={3}>
              <Divider sx={(theme: Theme) => ({ borderColor: theme.palette.grey[500] })} />
            </Grid>
            <Grid item xs={12} sm={6} mt="-9px">
              <KeyValue title="Family Name" description={familyName} />
            </Grid>
            {(
              isModuleAllowed({
                value: (role ?? ""),
                compareArr: [USER_ROLES.AMCAPPROVER]
              }) &&
              !familyId
            ) && (
                <Grid item xs={12} sm={6} mt={{ xs: "10px", sm: "-9px" }}>
                  <FormControl fullWidth sx={{ my: { xs: 1, sm: 1, md: 2 } }}>
                    <InputLabel
                      sx={(theme: Theme) => ({
                        ...theme.typography.body_500,
                      })}
                    >
                      Existing Family Name*
                    </InputLabel>
                    <BootstrapSelect
                      label="Existing Family Name*"
                      value={selectedFamilyId?.value ?? ""}
                      sx={{
                        '& .Mui-disabled': {
                          pointerEvents: 'all',
                        },
                      }}
                      MenuProps={{
                        sx: {
                          '.MuiPaper-root ': {
                            maxWidth: { xs: '100%', sm: '31%', md: '26%' },
                            maxHeight: '20%',
                            overflowX: 'auto',
                          },
                        },
                        disableAutoFocusItem: true,
                        MenuListProps: {
                          disableListWrap: true,
                        },
                      }}
                      onClose={() => {
                        setQuery('');
                      }}
                      onChange={({ target: { value } }: SelectChangeEvent<unknown>) => {
                        const selectedFamilyDetails = (familyListData ?? []).find(obj => obj?.value === value)

                        setSelectedFamilyId(selectedFamilyDetails ?? { key: "", value: "" })
                      }}
                      renderValue={(Selectedvalue) => {
                        const selectedKey = familyListData.find((_item) => _item.value == Selectedvalue);
                        return (
                          <Typography
                            variant='body_500'
                            sx={{
                              whiteSpace: { xs: 'pre-wrap', sm: 'nowrap' }
                            }}
                            component="span">
                            {selectedKey?.key ?? ""}
                          </Typography>
                        );
                      }}
                    >
                      <SearchFieldWrapper searchFieldPlaceholder="Search Family" setQuery={setQuery} />
                      {renderFilteredOptions(familyListData, query)}
                    </BootstrapSelect>
                  </FormControl>
                </Grid>
              )}
            {/* UBO Declaration Section */}
            {ubo_declaration_type && (
              <>
                <Grid item xs={12} my={3}>
                  <Divider sx={(theme: Theme) => ({ borderColor: theme.palette.grey[500] })} />
                </Grid>
                <SubHeading
                  sx={{
                    color: 'common.black',
                    letterSpacing: 0.5 + 'px',
                    padding: { xs: '10px 10px', sm: '10px 30px' },
                  }}>
                  {'UBO Declaration'}
                </SubHeading>
                <Item
                  sx={{
                    marginTop: '10px',
                    marginBottom: '5px',
                  }}>
                  {'We hereby declare that:'}
                </Item>
                <Box
                  sx={{
                    mt: 1,
                    width: '100%',
                    display: 'flex',
                    alignItems: 'baseline',
                    flexDirection: { xs: 'column', sm: 'row' },
                  }}>
                  {uboTypesMdms && (
                    <>
                      <Item sx={{ pr: 1 }}>
                        {getUboDeclarationType(uboTypesMdms, ubo_declaration_type) ===
                          'None of the above'
                          ? 'Our company is a '
                          : getUboDeclarationType(uboTypesMdms, ubo_declaration_type)}
                      </Item>
                      <ItemDetails>
                        {getUboDeclarationValue(
                          uboTypesMdms,
                          ubo_declaration_type,
                          ubo_declaration_value
                        )}
                      </ItemDetails>
                    </>
                  )}
                </Box>
              </>
            )}
          </Grid>
        </Box>
      </Box>
    </>
  );
}
